<template>
	<div class="pagesContent">
			<!-- 顶栏容器 -->
				<el-card>
					<el-form ref="Search" :model="Search" label-width="100px" inline>
						<el-form-item label="公司编号">
							<el-input v-model="Search.CompanyId" placeholder="请输入公司编号" size="small" @change="searchSubmit"></el-input>
						</el-form-item>
						<el-form-item label="公司名称">
							<el-input v-model="Search.LikeCompanyName" placeholder="请输入公司名称" size="small" @change="searchSubmit">
							</el-input>
						</el-form-item>
						<el-form-item label="地区">
							<el-cascader size="small" :options="options" v-model="selectedOptions" clearable
								:props="{ checkStrictly: true }" popper-class='aaa' @change="chooseRegion">
							</el-cascader>
						</el-form-item>
					</el-form>
				</el-card>
			<!-- 主体内容 -->
				<el-card style="margin-top: 10px;" class="card-box section">
					<div class="single-title">
					续费记录
					</div>
					<div class="single-model-other">
						<el-table size="mini" max-height="500" :data="PayRecord" stripe border style="width: 100%" >
							<el-table-column type="index" label="编号" align="center"></el-table-column>
							<el-table-column prop="PermissionInfo.CompanyName" label="公司名称" align="center" min-width="200"></el-table-column>
							<el-table-column prop="AuthDate" label="开通时间" min-width="100" align="center">
								<template slot-scope="scope">{{scope.row.AuthDate | dateYMDFormat}}</template>
							</el-table-column>
							<el-table-column prop="Deadline" label="到期时间" min-width="100" align="center">
								<template slot-scope="scope">{{scope.row.Deadline | dateYMDFormat}}</template>
							</el-table-column>
							<el-table-column prop="AuthPerson" label="开通人" align="center" min-width="80"></el-table-column>
							<el-table-column prop="Remark" label="备注" align="center" min-width="250"></el-table-column>
						</el-table>
						<el-pagination style="margin-top: 10px;" background :current-page.sync="table.PageIndex" :page-size.sync="table.PageSize"
							:page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="table.TotalCount"
							@size-change="handleSizeChange" @current-change="getAllPayLog">
						</el-pagination>
					</div>
				</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//顶部搜索
				Search: {
					CompanyId: '', //公司编号
					LikeCompanyName: '', // 公司名称
					ProvinceCode: '', //省代码
					CityCode: '', //市代码
					AreaCode: '', //区代码
				},
				//获取地区
				options: [],
				selectedOptions: [],
				table:{
					PageIndex:1,
					PageSize:10,
					TotalCount:null,
				},
				//续费记录
				PayRecord:[],
			}
		},
		mounted() {
			this.getAddress()
      		this.getAllPayLog()
		},
		methods: {
			//续费记录
			getAllPayLog(){
				this.$http.getPaginatedDredgeLogPag(this.table.PageIndex,this.table.PageSize,this.Search).then(res=>{
					console.log(res)
					if(res.status == 200) {
						this.PayRecord = res.data.Items
						this.table.TotalCount = res.data.TotalCount
					}
				})
			},
			handleSizeChange(val) {
				this.table.PageIndex = 1
				this.getAllPayLog()
			},
			/* 搜索 重置 */
			searchReset() {
				this.Search = this.$options.data.call(this).Search
			},
			/* 搜索 提交搜索 */
			searchSubmit() {
				this.table.PageIndex = 1
				this.getAllPayLog()
			},
			/* 顶部选择地区 */
			chooseRegion(value) {
				// console.log(value)
				var regionList = value
				if (value.length == 3) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = regionList[2]
				} else if (value.length == 2) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = ""
				} else if (value.length == 1) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				} else {
					this.Search.ProvinceCode = ""
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				}
				this.searchSubmit()
			},
			/* 获取地区 */
			getAddress() {
				this.$http.getAllAddress().then(res => {
					if (res.status == 200) {
						this.options = res.data
						// console.log(this.options)
					} else {
						this.$message.error({
							message: '查询地区失败！'
						})
					}
				})
			},
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}


	/* 顶部地址 */
	.el-cascader-menu__wrap {
		height: 260px;
	}

	.el-cascader-menu {
		min-width: 260px;
	}

	.el-cascader-panel {
		font-size: 16px;
	}

	.aaa .el-radio__inner {
		top: -18px;
		left: -19px;
		border-radius: 0;
		border: 0;
		width: 170px;
		height: 34px;
		background-color: transparent;
		cursor: pointer;
		box-sizing: border-box;
		position: absolute;
	}
	.aaa .el-radio__input.is-checked .el-radio__inner {
		background: transparent;
	}

	.card-box {
		margin-bottom: 40px;
	}
	.single-model-other {
		padding: 10px 0;
	}
	.single-title {
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		font-weight: 800;
		border-bottom: #CCCCCC 1px solid;
	}
	.single-model-company {
		padding: 20px 0 0 40px;
		margin-bottom: 40px;
	}

	.el-card__body{
		padding: 10px;
	}
</style>
